module.exports = __webpack_public_path__ + "img/75.31762743.svg";